<template>
  <div class="container-fluid bg-pie position-relative px-0 ini no-print">
    <!-- menu 'acordeón' móviles 2 -->
    <div class="accordion mov d-block d-md-none" id="accordionLandingMov">
      <div class="card">
        <router-link :to="{name:'Noticias'}">
          <div class="card-header bg-menu-gris1 py-5 px-4" id="headingThree">
            <button class="btn btn-link collapsed" type="button" aria-expanded="false">
              <h2 class="mt-1 mb-0">Noticias destacadas</h2>
            </button>
          </div>
        </router-link>
        <div
          id="collapseThree"
          class="collapse"
          aria-labelledby="headingThree"
          data-parent="#accordionLandingMov"
        >
          <div class="card-body mt-4 pb-4">--</div>
        </div>
      </div>
      <div class="card">
        <router-link :to="{name:'Fechas'}">
          <div class="card-header bg-menu-gris2 py-5 px-4" id="headingFour">
            <button class="btn btn-link collapsed" type="button" aria-expanded="false">
              <h2 class="mt-1 mb-0">Fechas importantes</h2>
            </button>
          </div>
        </router-link>
        <div
          id="collapseFour"
          class="collapse"
          aria-labelledby="headingFour"
          data-parent="#accordionLandingMov"
        >
          <div class="card-body mt-4 pb-4">--</div>
        </div>
      </div>
      <div class="card">
        <router-link :to="{name:'SitiosDestacados'}">
          <div class="card-header bg-menu-gris3 py-5 px-4" id="headingFive">
            <button class="btn btn-link collapsed text-dark" type="button" aria-expanded="false">
              <h2 class="mt-1 mb-0">Sitios de interés</h2>
            </button>
          </div>
        </router-link>
        <div
          id="collapseFive"
          class="collapse"
          aria-labelledby="headingFive"
          data-parent="#accordionLandingMov"
        >
          <div class="card-body mt-4 pb-4">--</div>
        </div>
      </div>
    </div>
    <!--<nav class="navbar col p-0 mov mov2 d-block d-md-none">
      <nav class="navbar segundo d-block">
        <ul class="navbar-nav pr-0">
          <li class="col text-center py-5 px-4 bg-menu-gris2">
            <div
              class="dropdown-toggle text-nowrap text-uppercase p-0"
              id="dropdownMenu2"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <a href="#">Noticias destacadas</a>
            </div>
          </li>
          <li class="col text-center py-5 px-4 bg-menu-gris1">
            <div
              class="dropdown-toggle text-nowrap text-uppercase p-0"
              id="dropdownMenu2"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <a href="#">Fechas importantes</a>
            </div>
          </li>
          <li class="col text-center py-5 px-4 bg-menu-gris3">
            <div
              class="dropdown-toggle text-nowrap text-uppercase p-0"
              id="dropdownMenu2"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <a href="#">Sitios de interés</a>
            </div>
          </li>
        </ul>
      </nav>
    </nav>-->

    <!-- Footer desktop -->
    <footer class="container-fluid px-0 px-md-2 d-none d-md-block">
      <!--  mb-md-3 -->
      <div class="container bg-gris-oscuro pt-4 pb-3">
        <div class="row pr-3">
          <div class="col-5 mr-auto position-md-absolute">
            <div class="row">
              <div class="row col-md mr-auto">
                <img class="logo-pie" src="@/assets/img/monocromo-blanco_mineduc.png" alt />
              </div>
            </div>
          </div>
          <div class="col-7 ml-auto mt-2 mr-3 mr-md-0">
            <div class="row social ml-auto">
              <!-- align-self-end -->

              <div class="row col-md-8 mr-auto">
                <p class="text-white mt-1 mb-2">
                  Ministerio de Educación - Teléfono +56 2 2406 6000
                  <br />
                  <a
                    href="https://acceso.mineduc.cl/wp-content/uploads/2020/07/TERMINOS_Y_CONDICIONES_USO_WEB_ACCESO.pdf"
                    target="_blank"
                    class="text-gris"
                  >Ver Términos y Condiciones de uso de este sitio</a>
                  <br />
                  <small class="text-gris">V. {{version}}</small>
                </p>
              </div>

              <ul class="col d-flex justify-content-end">
                <li class>
                  <a href="https://twitter.com/SubseEdSuperior" target="_blank">
                    <i class="fab fa-twitter text-blanco"></i>
                  </a>
                </li>
                <li class>
                  <a href="https://www.facebook.com/SubseEdSuperior" target="_blank">
                    <i class="fab fa-facebook-f text-blanco"></i>
                  </a>
                </li>
                <li class="mr-0 pr-0">
                  <a href="https://www.instagram.com/subseedsuperior/" target="_blank">
                    <i class="fab fa-instagram text-blanco"></i>
                  </a>
                </li>
              </ul>
            </div>

            <div class="row">
              <div class="col-md-4 pr-0 text-right text-md-left">
                <div class="gob-link">
                  <a
                    href="https://www.mineduc.cl/wp-content/uploads/sites/19/2019/06/Primer-trimestre-2019-MINEDUC.pdf"
                    target="_blank"
                  >
                    <img
                      class="img-fluid"
                      src="@/assets/img/banda_mineduc.png"
                      alt="Ministerio de Educación"
                    />
                    <p class>
                      Información
                      <strong>Presupuestaria</strong> Mineduc
                    </p>
                  </a>
                </div>
              </div>

              <div class="col-md-4 pr-0 text-right text-md-left">
                <div class="gob-link">
                  <a
                    href="https://www.portaltransparencia.cl/PortalPdT/pdtta/-/ta/AJ025"
                    target="_blank"
                  >
                    <img
                      class="img-fluid"
                      src="@/assets/img/banda_mineduc.png"
                      alt="Ministerio de Educación"
                    />
                    <p class>
                      Gobierno
                      <strong>Transparente</strong>
                      <br />Sub. de Educación Superior
                    </p>
                  </a>
                </div>
              </div>

              <div class="col-md-4 pr-0 pr-md-3 text-right text-md-left">
                <div class="gob-link">
                  <a href="https://www.ayudamineduc.cl/ley-transparencia" target="_blank">
                    <img
                      class="img-fluid"
                      src="@/assets/img/banda_mineduc.png"
                      alt="Ministerio de Educación"
                    />
                    <p class>
                      Solicitud de información
                      <br />
                      <strong>Ley de Transparencia</strong>
                    </p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>

    <!-- Footer móviles -->

    <footer class="mov container-fluid px-0 px-md-2 d-block d-md-none">
      <!--  mb-md-3 -->
      <div class="container bg-gris-oscuro pt-4 pb-3">
        <div class="row">
          <div class="col-5 mr-auto">
            <div class="row">
              <div class="row mr-auto">
                <img class="logo-pie" src="@/assets/img/monocromo-blanco_mineduc.png" alt />
              </div>
            </div>
          </div>

          <div class="col-6 ml-auto">
            <div class="row social ml-auto">
              <!-- align-self-end -->

              <ul class="ml-4 text-nowrap">
                <li class>
                  <a href="https://twitter.com/SubseEdSuperior" target="_blank">
                    <i class="fab fa-twitter text-gris"></i>
                  </a>
                </li>
                <li class>
                  <a href="https://www.facebook.com/SubseEdSuperior" target="_blank">
                    <i class="fab fa-facebook-f text-gris"></i>
                  </a>
                </li>
                <li class="mr-0 pr-0">
                  <a href="https://www.instagram.com/subseedsuperior/" target="_blank">
                    <i class="fab fa-instagram text-gris"></i>
                  </a>
                </li>
              </ul>
            </div>

            <div class="row">
              <ul>
                <li>
                  <a
                    href="https://www.mineduc.cl/wp-content/uploads/sites/19/2019/06/Primer-trimestre-2019-MINEDUC.pdf"
                    target="_blank"
                  >
                    <p class>
                      Información
                      <strong>Presupuestaria</strong> Mineduc
                    </p>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.portaltransparencia.cl/PortalPdT/pdtta/-/ta/AJ025"
                    target="_blank"
                  >
                    <p class>
                      Gobierno
                      <strong>Transparente</strong>
                      <br />Sub. de Educación Superior
                    </p>
                  </a>
                </li>
                <li>
                  <a href="https://www.ayudamineduc.cl/ley-transparencia" target="_blank">
                    <p class>
                      Solicitud de información
                      <br />
                      <strong>Ley de Transparencia</strong>
                    </p>
                  </a>
                </li>
                <li>
                  <a
                    href="https://acceso.mineduc.cl/wp-content/uploads/2020/07/TERMINOS_Y_CONDICIONES_USO_WEB_ACCESO.pdf"
                    target="_blank"
                    class="text-gris"
                  >
                    <p class="text-gris">Ver Términos y Condiciones de uso de este sitio</p>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>

    <!-- Fin footer -->
  </div>
</template>
<script>
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      version: VERSION
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/wrapper/Footer.vue